import { useEffect } from 'react'
import PropTypes from 'prop-types'

/**
 * Ported from pitstop-ui/src/components/EForm/FormField/cell-boolean-radio.jsx
 * Displays a boolean/radio value as "Yes" / "No" in read-only mode.
 * In edit mode renders Yes/No radio buttons.
 */

const CellBooleanRadioComponent = ({
  isReadOnly,
  payload,
  parentProps,
  inputProps,
  setInputProps,
  updatePayload,
  validateSchema,
  getFieldValue,
}) => {
  useEffect(() => {
    setInputProps({
      ...inputProps,
      disabled: isReadOnly,
      value: getFieldValue(payload, parentProps),
    })
  }, [payload])

  const value = inputProps?.value

  if (isReadOnly) {
    return (
      <span className="overflow-hidden whitespace-nowrap">
        {value === true ? 'Yes' : value === false ? 'No' : ''}
      </span>
    )
  }

  function onChange(e) {
    if (isReadOnly) return
    const selected = e.target.value === 'true'
    setInputProps({ ...inputProps, value: selected })
    updatePayload(selected)
    validateSchema(selected)
  }

  return (
    <div className="eform-radio-group" data-testid="eform-boolean-radio">
      <label style={{ marginRight: '1rem' }}>
        <input
          type="radio"
          name={parentProps?.join('-')}
          value="true"
          checked={value === true}
          onChange={onChange}
          disabled={isReadOnly}
        />
        {' Yes'}
      </label>
      <label>
        <input
          type="radio"
          name={parentProps?.join('-')}
          value="false"
          checked={value === false}
          onChange={onChange}
          disabled={isReadOnly}
        />
        {' No'}
      </label>
    </div>
  )
}

CellBooleanRadioComponent.propTypes = {
  isReadOnly: PropTypes.bool,
  payload: PropTypes.object,
  parentProps: PropTypes.array,
  inputProps: PropTypes.object,
  setInputProps: PropTypes.func,
  updatePayload: PropTypes.func,
  validateSchema: PropTypes.func,
  getFieldValue: PropTypes.func,
}

export default CellBooleanRadioComponent
